<template>
  <router-view></router-view>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    this.$eventBus.$emit('showLoading', true)
    try {
      if (this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')) {
        this.show = true
        if (this.$route.path === '/v-admin/talent-pool/group-list') {
          return
        } else if (this.$route.name === 'talentApplicationList') {
          return
        } else if (this.$route.name === 'talentPotentialApplicationList') {
          return
        }
        this.$router.push({ path: '/v-admin/talent-pool/group-list' })
      } else {
        if (this.$route.path === '/v-admin/talent-pool/-1') {
          return
        } else if (this.$route.name === 'talentPotentialApplicationList') {
          return
        }
        this.$router.push({ path: '/v-admin/talent-pool/-1' })
      }
    } finally {
      this.$eventBus.$emit('showLoading', false)
    }
  },
  methods: {

  }
}
</script>
